import { Badge, SettingsCard, SettingsCardFooter, SettingsCardRow } from 'design-system';

import UpgradeToPremiumButton from '@/features/_shared/UpgradeToPremium/UpgradeToPremiumButton';
import { DateTextVariants, useDateText, useUserDetails } from '@/features/_shared/user';

const AccountDetails = () => {
  const { isUserExpired, currentSubscription, expiredDate } = useUserDetails();
  const { formatDateString } = useDateText();
  const accessLevel = isUserExpired ? 'Expired' : currentSubscription;

  return (
    <SettingsCard
      action={
        <Badge
          className='uppercase'
          variant='accentOutline'
        >
          {accessLevel}
        </Badge>
      }
      title='Account Details'
    >
      <SettingsCardRow label='Access Level'>{accessLevel}</SettingsCardRow>
      <SettingsCardRow label='Expiry Date'>
        {expiredDate ? formatDateString(expiredDate.toJSON(), DateTextVariants.FULL) : 'Never'}
      </SettingsCardRow>
      <SettingsCardFooter>
        <UpgradeToPremiumButton type={isUserExpired ? 'expired' : 'manage'} />
      </SettingsCardFooter>
    </SettingsCard>
  );
};

export default AccountDetails;
